import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvestmentService {
  private baseUrl = environment.typeSense.url;

  constructor(private http: HttpClient) {}

  async getInvestmentChecklist(symbol: string): Promise<any> {
   // Mock response for testing/development
   // const mockResponse = {
   //   id: 'AAPL',
   //   expected_annual_return: '30.84',
   //   target_price: '255',
   //   index: 'S&P500',
   //   risk_level: '0.56',
   //   sharpe_ratio: '0.89',
   //   dividendYield: '0.51',
   //   industry_avg_dividend_yield: '42,260.47',
   //   scale: 'This stock offers lower dividend yield compared to the market'
   // };

   // Uncomment to use mock data for testing
   // return Promise.resolve(mockResponse);
   return await lastValueFrom(this.http.get(`${this.baseUrl}/collections/investment_checklist/documents/${symbol}`))
   //  const url = `${this.baseUrl}get_investment_checklist?company_symbol=${symbol}`;
   //  try {
   //    const response = await lastValueFrom(this.http.get(url));
   //    return response;
   //  } catch (error) {
   //    console.error('API Error:', error);
   //    throw error;
   //  }
  }
}
